import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useContext } from 'react';
import clsx from 'clsx';
import { BORDER_TOP_BOTTOM } from '../utils/constant';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';

var CellGroup = function CellGroup(props) {
  var title = props.title,
      border = props.border,
      inset = props.inset;

  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('cell-group', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var renderGroup = function renderGroup() {
    return /*#__PURE__*/React.createElement("div", {
      className: clsx(bem({
        inset: inset
      }), _defineProperty({}, BORDER_TOP_BOTTOM, !inset && border))
    }, props.children);
  };

  var renderTitle = function renderTitle() {
    if (title) return /*#__PURE__*/React.createElement("div", {
      className: clsx(bem('title'))
    }, title);
    return null;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: props.style
  }, renderTitle(), renderGroup());
};

CellGroup.defaultProps = {
  border: true
};
export default CellGroup;